<template>
  <div
    class="table-item-content"
    v-if="props.examen?.id">
    <div
      class="table-item-row"
      v-if="props.examen.expire">
      <div class="table-item-content-text">
        <span>Non réalisé</span>
      </div>
    </div>
    <div
      class="table-item-row"
      v-else-if="props.examen.id && !props.examen.termine">
      <div class="table-item-content-text">
        <span>{{ props.examen.reponsesJson ? 'Reprendre' : 'Commencer' }}</span>
      </div>
    </div>
    <template v-else-if="props.examen.repondu && props.examen.termine">
      <div class="table-item-row">
        <div class="table-item-content-icon">
          <IconValidate20Green />
        </div>
        <div class="table-item-content-text">
          <span>Réalisé</span>
        </div>
      </div>
      <div
        class="table-item-row"
        v-if="props.examen.nbreBonnesResponses">
        <div v-bind:class="`table-item-content-card`">
          <span
            >Note : {{ props.examen.nbreBonnesResponses }}/{{
              props.examen.nbreQuestions
            }}</span
          >
        </div>
      </div>
    </template>
  </div>
</template>

<script setup lang="ts">
  import IconValidate20Green from '@/assets/img/refonte/icons/information/icon-validate-20-green.svg?component';

  const props = withDefaults(
    defineProps<{
      examen?: Object;
    }>(),
    {}
  );
</script>

<style lang="scss" scoped>
  .table-item-content {
    @apply flex flex-col;
    min-height: 20px;
    gap: 8px;
    padding-top: 2px;

    .table-item-row {
      @apply flex items-center;
      gap: 8px;
    }
    .table-item-content-icon {
      @apply flex shrink-0 items-center justify-center;
      width: 20px;
      height: 20px;
      :deep(svg) {
        @apply text-refonte_blue-200;
        width: 20px;
        height: 20px;
      }
    }
    .table-item-content-text {
      @apply flex-grow text-refonte-black;
      font-size: 14px;
      font-weight: 400;
      line-height: 125%;
    }
    .table-item-content-card {
      @apply bg-accent-500 text-core-100;
      border-radius: 4px;
      padding: 4px 8px;
      font-size: 11px;
      font-weight: 400;
    }
    .table-item-content-card-blue {
      @apply bg-refonte_blue-600;
    }
    .table-item-content-card-light-blue {
      @apply bg-refonte_blue-100 text-core-800;
      margin-bottom: 2px;
    }
  }
</style>
